import { render, staticRenderFns } from "./TaxesOwed.vue?vue&type=template&id=277b3b0a&scoped=true&"
import script from "./TaxesOwed.vue?vue&type=script&lang=js&"
export * from "./TaxesOwed.vue?vue&type=script&lang=js&"
import style0 from "./TaxesOwed.vue?vue&type=style&index=0&id=277b3b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b3b0a",
  null
  
)

export default component.exports